(function () {
    'use strict';

    angular
        .module('app', [
            'ngRoute',
            'ngAnimate',
            'ngCookies',
            'ngSanitize',
            'ngMessages',
            'ui.bootstrap',
            'ui.validate',
            'stToast', // toastr alert messages (customized css for full top)
            'stConfirmPopover', // 'Are you sure?' popover
            'stSpinner', // Spinner
            'stValidators'
        ])
        .factory("httpInterceptor", httpInterceptor)
        .config(routes)
        .config(toastr)
        .config(modal)
        .config(spinner)
        .config(addHttpInterceptors);

    function routes($routeProvider, $locationProvider) {
        $locationProvider.hashPrefix('');

        //const abilities = {
        //	VIEW: 'ThirdPartySalesRep - View',
        //	EDIT: 'ThirdPartySalesRep - Edit'
        //};

        $routeProvider
            //.when('/', { template: '<home></home>', resolve: authorized([abilities.VIEW, abilities.EDIT]) })
            .when('/', { template: '<home></home>' })
            .when('/create-password/:key?', { template: '<create-password key="$resolve.key"></create-password>', resolve: { key: ['$route', $route => $route.current.params.key] }  })
            .when('/customers/:customerId/items', { template: '<items customer-id="$resolve.customerId"></users>', resolve: { session: getSession(), customerId: ['$route', $route => $route.current.params.customerId] } })
            .when('/customers/:customerId/users', { template: '<users customer-id="$resolve.customerId"></users>', resolve: { session: getSession(), customerId: ['$route', $route => $route.current.params.customerId] } })
            .when('/customers/:customerId/users/create', { template: '<user-details customer-id="$resolve.customerId"></user-details>', resolve: { session: getSession(), customerId: ['$route', $route => $route.current.params.customerId] } })
            .when('/forgot-password', { template: '<forgot-password></forgot-password>' })
            .when('/home', { template: '<home></home>' })
            .when('/items', { template: '<items></items>', resolve: loggedIn() })
            .when('/managers/:managerId/pending-orders/', { template: '<pending-orders manager-id="$resolve.managerId"></pending-orders>', resolve: { session: getSession(), managerId: ['$route', $route => $route.current.params.managerId] } })
            .when('/order-approval/:linkId', { template: '<public-order link-id="$resolve.linkId"></public-order>', resolve: { linkId: ['$route', $route => $route.current.params.linkId] } })
            .when('/orders/create', { template: '<order></order>', resolve: loggedIn() })
            .when('/orders/:orderId/returns', { template: '<returns order-id="$resolve.orderId"></returns>', resolve: { session: getSession(), orderId: ['$route', $route => $route.current.params.orderId] } })
            .when('/orders/:orderId/replace-lost-shipment/:shipmentId', { template: '<replace-lost-shipment order-id="$resolve.orderId" shipment-id="$resolve.shipmentId"></replace-lost-shipment>', resolve: { session: getSession(), orderId: ['$route', $route => $route.current.params.orderId], shipmentId: ['$route', $route => $route.current.params.shipmentId] } })
            .when('/orders/:orderId', { template: '<order order-id="$resolve.orderId"></order>', resolve: { session: getSession(), orderId: ['$route', $route => $route.current.params.orderId] } })
            .when('/orders', { template: '<orders></orders>', resolve: loggedIn() })
            .when('/npc-admins/create', { template: '<npc-admin></npc-admin>', resolve: loggedIn() })
            .when('/npc-admins/:userId', { template: '<npc-admin user-id="$resolve.userId"></npc-admin>', resolve: { session: getSession(), userId: ['$route', $route => $route.current.params.userId] } })
            .when('/npc-admins', { template: '<npc-admins></npc-admins>', resolve: loggedIn() })
            .when('/shipping-label/:returnId', { template: '<shipping-label return-id="$resolve.returnId"></shipping-label>', resolve: { returnId: ['$route', $route => $route.current.params.returnId] } })
            .when('/update-password', { template: '<update-password></update-password>', resolve: loggedIn() })
            .when('/users/create', { template: '<user-details></user-details>', resolve: loggedIn() })
            .when('/users/:userId/returns', { template: '<returns user-id="$resolve.userId"></returns>', resolve: { session: getSession(), userId: ['$route', $route => $route.current.params.userId] } })
            .when('/users/:userId/orders/create', { template: '<order user-id="$resolve.userId"></order>', resolve: { session: getSession(), userId: ['$route', $route => $route.current.params.userId] } })
            .when('/users/:userId/orders', { template: '<orders for-user-id="$resolve.userId"></orders>', resolve: { session: getSession(), userId: ['$route', $route => $route.current.params.userId] } })
            .when('/users/:userId', { template: '<user-details user-id="$resolve.userId"></user-details>', resolve: { session: getSession(), userId: ['$route', $route => $route.current.params.userId] } })
            .when('/users', { template: '<users></users>', resolve: loggedIn() })
            .otherwise({ redirectTo: '/' });

        function loggedIn() {
            return {
                session : getSession()
            }
        }

        function getSession() {
            return [
                'tpsrService', function (tpsr) {
                    return tpsr.getSession();
                }
            ];
        }

        // Verify user is logged in, with optional abilities, and return the user's session in the 'session' property.
        // Ex:
        //  .when('/my-component', {
        //      template: '<my-component session='$resolve.session'></my-component>',
        //      resolve: authorized(['Required Ability'])
        //      // resolve: authorized() // only need to be logged in, no extra abilities
        //  })
        //function authorized(abilities) {
        //    return {
        //        session: session(abilities)
        //    };
        //};

        // Verify user is logged in, with optional abilities, and return the user's session in the 'session' property. Use this style when extra resolve parameters are needed.
        // Ex:
        //  .when('/my-component/:myComponentId', {
        //      template: '<my-component my-component-id='$resolve.myComponentId' session='$resolve.session'></my-component>',
        //      resolve: {
        //          session: session(['Required Ability']),
        //          //session: session(), // only need to be logged in, no extra abilities
        //          myComponentId: ['$route', $route => $route.current.params.myComponentId]
        //      }
        //  })
        //function session(abilities = []) {
        //    return [
        //        'stAuthFactory', function (auth) {
        //            return auth.authorize(abilities).then(r => r.data);
        //        }
        //    ];
        //}

    }
    routes.$inject = ['$routeProvider', '$locationProvider'];

    function addHttpInterceptors($httpProvider) {
        $httpProvider.interceptors.push("httpInterceptor");
    }
    addHttpInterceptors.$inject = ["$httpProvider"];

    function httpInterceptor($q, $location, clientDataService) {
        return {
            'request': config => {
                const token = clientDataService.getToken();
                if (token) {
                    config.headers.Authorization = `${token}`;
                }
                return config || $q.when(config);
            },
            'responseError': response => {
                if (response.status === 401) {
                    console.log("responseError", response);
                    $location.url(`/`)
                    //$http = $http || $injector.get("$http");
                    //loginModal = loginModal || $injector.get("loginModal");
                    //return loginModal().then(() => $http(response.config));
                }

                if (response.status === 403) {
                }

                return $q.reject(response);
            }
        };
    }
    httpInterceptor.$inject = ["$q", "$location", "clientDataService"];

    function toastr(toastrConfig) {

        angular
            .extend(toastrConfig, {
                positionClass: 'toast-top-full-width',
                preventOpenDuplicates: true,
                timeOut: 3000
            });

    }
    toastr.$inject = ['toastrConfig'];

    function modal($uibModalProvider) {
        angular.extend($uibModalProvider.options, {
            controllerAs: '$ctrl',
            //size: 'lg',
            backdrop: 'static',
            keyboard: false
        });
    }
    modal.$inject = ['$uibModalProvider'];


    function spinner(spinnerProvider) {
        spinnerProvider
            .showAll(true);
    }
    spinner.$inject = ['stSpinnerProvider'];
})();